export const BRANDING_THEMES = {
  radiflow: {
    name: 'radiflow',
  },
  wago: {
    name: 'wago',
  },
  'device-total': {
    name: 'device-total'
  }
} as const;